/**
 * @param {object} dataAccount  - object with charity informations with values for back-office : isValidated, isOnboardingCompleted, isReadyToOnboard
 */
export const setCharityLocalStorage = (dataAccount) => {
    localStorage.setItem(
        'is_validated',
        JSON.stringify(!!dataAccount?.isValidated),
    );

    localStorage.setItem(
        'is_onboarding_completed',
        JSON.stringify(!!dataAccount?.isOnboardingCompleted),
    );

    localStorage.setItem(
        'is_ready_to_onboard',
        JSON.stringify(!!dataAccount?.isReadyToOnboard),
    );
};
